<template>
    <div>
        <AnnouncementBar />
        <HeaderMain />
        <div class="flex min-h-[calc(100vh-var(--header-total-height))] flex-col items-center">
            <main class="flex w-full flex-1 flex-col">
                <slot />
            </main>
            <FooterMain />
        </div>
    </div>
</template>
